import settings from '@/defaultSettings'

export default {
  namespaced: true,
  state: settings,
  mutations: {
    setDevice (state, isMobile) {
      state.isMobile = isMobile
    },
    setTheme (state, theme) {
      state.theme = theme
    },
    setLayout (state, layout) {
      state.layout = layout
    },
    setFixedHeader (state, fixedHeader) {
      state.fixedHeader = fixedHeader
    },
    setFixSiderbar (state, fixSiderbar) {
      state.fixSiderbar = fixSiderbar
    },
    setMultipage (state, multipage) {
      state.multipage = multipage
    }
  }
}
